import React from 'react';
import { noop } from 'lodash';

export const AdminTableActionButtonContext = React.createContext({
  open: noop,
  close: noop,
});
